
import createIcon from "./createIcon";

export const PlusCircleIcon = createIcon('PlusCircle', (props) => {
  return (
    <svg {...props}>
      <path id="path" d="M13.33 7.33C13.33 10.64 10.64 13.33 7.33 13.33L7.33 14.66C11.38 14.66 14.66 11.38 14.66 7.33L13.33 7.33ZM7.33 13.33C4.01 13.33 1.33 10.64 1.33 7.33L0 7.33C0 11.38 3.28 14.66 7.33 14.66L7.33 13.33ZM1.33 7.33C1.33 4.01 4.01 1.33 7.33 1.33L7.33 0C3.28 0 0 3.28 0 7.33L1.33 7.33ZM7.33 1.33C10.64 1.33 13.33 4.01 13.33 7.33L14.66 7.33C14.66 3.28 11.38 0 7.33 0L7.33 1.33Z" fill={props.color} fillOpacity="1.000000" fillRule="nonzero" />
      <path id="矢量 9" d="M7.99 4.66C7.99 4.29 7.7 4 7.33 4C6.96 4 6.66 4.29 6.66 4.66L6.66 6.66L4.66 6.66C4.29 6.66 4 6.96 4 7.33C4 7.7 4.29 8 4.66 8L6.66 8L6.66 10C6.66 10.36 6.96 10.66 7.33 10.66C7.7 10.66 7.99 10.36 7.99 10L7.99 8L10 8C10.36 8 10.66 7.7 10.66 7.33C10.66 6.96 10.36 6.66 10 6.66L7.99 6.66L7.99 4.66Z" fill={props.color} fillOpacity="1.000000" fillRule="evenodd" />
    </svg >
  )
});
